import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import ChooseCinemaBtn from './components/ChooseCinemaBtn/ChooseCinemaBtn'
import LogoHeader from './components/LogoHeader/LogoHeader'
import ShoppingCart from './components/ShoppingCart/ShoppingCart'
import TopProgramMenu from './components/TopProgramMenu/TopProgramMenu'
import UserAvatar from './components/UserAvatar/UserAvatar'

import gtmStartLogin from 'services/gtm/gtmStartLogin'
import './HeaderMainBar.scss'

const HeaderMainBar = ({
    isAuthorized,
    tickets,
    basketValidity,
    openedChooseCinema,
    onCinema,
    onMenu,
    basketRelease,
    chosenCinema,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const onProgram = () => (location.href = `${process.env.REACT_APP_WEB_PORTAL_URL}program`)

    return (
        <Container fluid className={`header-main-bar d-flex justify-content-between align-items-center`}>
            <div className="header-main-bar--left d-flex">
                <LogoHeader />
                <ChooseCinemaBtn
                    onCinema={onCinema}
                    openedChooseCinema={openedChooseCinema}
                    isCounting={Boolean(tickets)}
                    chosenCinema={chosenCinema}
                />
                <TopProgramMenu programHandleClick={() => onProgram()} menuHandleClick={onMenu} />
            </div>

            <div className="header-main-bar--right d-flex align-items-center">
                <ShoppingCart tickets={tickets} basketValidity={basketValidity} basketRelease={basketRelease} />
                {!isAuthorized ? (
                    <ButtonCinestar
                        variant={'primary-v1'}
                        onClick={() => {
                            gtmStartLogin()
                            dispatch(push('/login'))
                        }}
                    >
                        {intl.formatMessage({ id: 'buttons.login' })}
                    </ButtonCinestar>
                ) : (
                    <UserAvatar />
                )}
            </div>
        </Container>
    )
}

export default HeaderMainBar
